var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 61,
    viewBox: "0 0 164 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_949_6192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.12214 39.2689C7.34702 39.2689 5.76914 38.8946 4.38848 38.1457C3.00783 37.3967 1.93126 36.3399 1.15876 34.9754C0.386253 33.5941 0 31.9964 0 30.1825C0 28.3685 0.386253 26.7709 1.15876 25.3896C1.93126 24.0083 3.00783 22.9433 4.38848 22.1944C5.76914 21.4455 7.34702 21.071 9.12214 21.071C11.4889 21.071 13.4695 21.6784 15.0638 22.8933V25.3397C13.6339 24.0583 11.7273 23.4176 9.34403 23.4176C8.01269 23.4176 6.82927 23.6922 5.79379 24.2413C4.77474 24.7905 3.97758 25.581 3.40231 26.6128C2.82704 27.628 2.5394 28.8178 2.5394 30.1825C2.5394 31.5472 2.82704 32.7453 3.40231 33.7771C3.99402 34.809 4.7994 35.5994 5.81844 36.1486C6.85392 36.6978 8.02912 36.9724 9.34403 36.9724C10.5603 36.9724 11.6451 36.8142 12.5984 36.4981C13.5681 36.1653 14.4639 35.641 15.2858 34.9254V37.3967C13.8065 38.6449 11.752 39.2689 9.12214 39.2689Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8912 32.2794L26.6289 21.4455H29.3163L34.1238 29.858L39.0054 21.4455H41.6681L35.3319 32.2794V38.8946H32.8912V32.2794Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5098 21.4455H61.4238C62.9524 21.4455 64.1358 21.8449 64.9741 22.6437C65.8123 23.4425 66.2315 24.6074 66.2315 26.1385C66.2315 27.0038 66.0261 27.7695 65.6151 28.4351C65.2206 29.0842 64.6947 29.5667 64.0372 29.8829C65.8781 30.4322 66.7986 31.7884 66.7986 33.9519C66.7986 34.967 66.5766 35.8491 66.1329 36.598C65.7055 37.3302 65.1138 37.896 64.3577 38.2954C63.6016 38.6948 62.7634 38.8946 61.843 38.8946H53.5098V21.4455ZM61.1034 28.9343C61.9087 28.9343 62.5415 28.7097 63.0017 28.2603C63.4619 27.811 63.692 27.1453 63.692 26.2633C63.692 25.2481 63.4619 24.5408 63.0017 24.1415C62.558 23.7255 61.8676 23.5174 60.9308 23.5174H56.0245V28.9343H61.1034ZM61.2759 36.8226C62.2456 36.8226 62.9853 36.6062 63.4948 36.1735C64.0044 35.7409 64.2591 35.0003 64.2591 33.9519C64.2591 32.9034 63.9879 32.1545 63.4455 31.7052C62.9195 31.2559 62.1224 31.0312 61.0541 31.0312H56.0245V36.8226H61.2759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6455 21.4455H84.1928C86.05 21.4455 87.6608 21.795 89.025 22.4939C90.3892 23.1928 91.4329 24.1914 92.1561 25.4894C92.8957 26.7876 93.2656 28.3186 93.2656 30.0826C93.2656 32.9783 92.4356 35.1751 90.7754 36.6728C89.1318 38.154 86.8225 38.8946 83.8476 38.8946H78.6455V21.4455ZM83.8229 36.7727C86.124 36.7727 87.8499 36.1986 89.0003 35.0503C90.1509 33.902 90.7261 32.2461 90.7261 30.0826C90.7261 28.0856 90.1592 26.5046 89.025 25.3397C87.9074 24.1747 86.3048 23.5923 84.2174 23.5923H81.1603V36.7727H83.8229Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.106 21.4455H116.472V23.5923H107.62V29.1091H114.228V31.2309H107.62V36.7727H116.472V38.8946H105.106V21.4455Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.195 21.4455H139.561V23.5923H130.71V29.1091H137.317V31.2309H130.71V36.7727H139.561V38.8946H128.195V21.4455Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.285 21.4455H158.212C160.053 21.4455 161.467 21.8948 162.453 22.7935C163.439 23.6922 163.933 25.0069 163.933 26.7376C163.933 28.019 163.595 29.1091 162.921 30.0077C162.248 30.8898 161.294 31.4888 160.062 31.8051L163.858 38.8946H161.245L157.572 32.0048H153.799V38.8946H151.285V21.4455ZM157.794 29.858C158.895 29.858 159.766 29.6 160.407 29.0842C161.064 28.5515 161.393 27.7695 161.393 26.7376C161.393 25.606 161.072 24.7989 160.431 24.3162C159.807 23.8336 158.928 23.5923 157.794 23.5923H153.799V29.858H157.794Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9704 60.2464H9.78179L5.00113 52.7805V60.2464H3.8125V50.8568H5.00113L9.78179 58.3093V50.8568H10.9704V60.2464Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8835 51.8657V55.0001H19.2012V56.0089H15.8835V59.2374H19.5931V60.2464H14.6948V50.8568H19.5931V51.8657H15.8835Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6931 50.8703V51.8657H26.2112V60.2464H25.0227V51.8657H22.5278V50.8703H28.6931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2964 50.8703L40.6579 60.2464H39.3256L37.2096 52.6997L35.0152 60.2464L33.6959 60.2598L31.1489 50.8703H32.4159L34.4013 58.8205L36.5957 50.8703H37.928L40.0179 58.7935L42.0164 50.8703H43.2964Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4227 60.3406C49.5781 60.3406 48.8074 60.1387 48.1108 59.7352C47.4142 59.3226 46.8612 58.7532 46.4519 58.0267C46.0514 57.2914 45.8511 56.4663 45.8511 55.5516C45.8511 54.6368 46.0514 53.8162 46.4519 53.0899C46.8612 52.3545 47.4142 51.785 48.1108 51.3815C48.8074 50.9689 49.5781 50.7627 50.4227 50.7627C51.2762 50.7627 52.0511 50.9689 52.7478 51.3815C53.4444 51.785 53.993 52.35 54.3936 53.0764C54.7942 53.8029 54.9944 54.6279 54.9944 55.5516C54.9944 56.4753 54.7942 57.3004 54.3936 58.0267C53.993 58.7532 53.4444 59.3226 52.7478 59.7352C52.0511 60.1387 51.2762 60.3406 50.4227 60.3406ZM50.4227 59.2778C51.0584 59.2778 51.6288 59.1254 52.1339 58.8205C52.6476 58.5155 53.0482 58.0806 53.3355 57.5156C53.6316 56.9506 53.7796 56.2959 53.7796 55.5516C53.7796 54.7982 53.6316 54.1436 53.3355 53.5875C53.0482 53.0226 52.652 52.5877 52.147 52.2828C51.6419 51.9778 51.0671 51.8254 50.4227 51.8254C49.7783 51.8254 49.2036 51.9778 48.6986 52.2828C48.1935 52.5877 47.793 53.0226 47.4968 53.5875C47.2095 54.1436 47.0658 54.7982 47.0658 55.5516C47.0658 56.2959 47.2095 56.9506 47.4968 57.5156C47.793 58.0806 48.1935 58.5155 48.6986 58.8205C49.2123 59.1254 49.7871 59.2778 50.4227 59.2778Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0555 60.2464L60.8872 56.4125H59.4504V60.2464H58.2617V50.8703H61.2007C61.8886 50.8703 62.4677 50.9913 62.938 51.2335C63.4169 51.4757 63.7739 51.8029 64.009 52.2155C64.2441 52.628 64.3617 53.0988 64.3617 53.628C64.3617 54.2736 64.1788 54.8431 63.813 55.3363C63.456 55.8296 62.9161 56.1569 62.1934 56.3183L64.4792 60.2464H63.0555ZM59.4504 55.4305H61.2007C61.8451 55.4305 62.3284 55.2691 62.6505 54.9462C62.9728 54.6145 63.1338 54.175 63.1338 53.628C63.1338 53.0719 62.9728 52.6415 62.6505 52.3365C62.3371 52.0316 61.8537 51.8792 61.2007 51.8792H59.4504V55.4305Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8442 60.2464L69.0954 55.9686V60.2464H67.9067V50.8703H69.0954V55.2153L72.8572 50.8703H74.3594L70.2318 55.565L74.3986 60.2464H72.8442Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6913 53.6145C88.6913 54.3947 88.43 55.0449 87.9076 55.565C87.3938 56.0762 86.6058 56.3318 85.5434 56.3318H83.7931V60.2464H82.6045V50.8703H85.5434C86.571 50.8703 87.3503 51.1258 87.8815 51.637C88.4214 52.1483 88.6913 52.8074 88.6913 53.6145ZM85.5434 55.3229C86.2051 55.3229 86.6928 55.1749 87.0063 54.879C87.3198 54.583 87.4766 54.1616 87.4766 53.6145C87.4766 52.4576 86.8322 51.8792 85.5434 51.8792H83.7931V55.3229H85.5434Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3905 50.8703L95.9552 60.2464H94.5837L91.1484 50.8703H92.4155L95.276 58.955L98.1365 50.8703H99.3905Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.995 50.8703V51.8657H105.513V60.2464H104.325V51.8657H101.83V50.8703H107.995Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.525 59.2509H120.713V60.2464H116.337V50.8703H117.525V59.2509Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.277 50.8703V51.8657H126.794V60.2464H125.606V51.8657H123.111V50.8703H129.277Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.272 50.8703C136.265 50.8703 137.122 51.0631 137.845 51.4487C138.577 51.8254 139.134 52.368 139.517 53.0764C139.909 53.7849 140.105 54.6189 140.105 55.5785C140.105 56.5381 139.909 57.3721 139.517 58.0806C139.134 58.78 138.577 59.3181 137.845 59.6948C137.122 60.0625 136.265 60.2464 135.272 60.2464H132.438V50.8703H135.272ZM135.272 59.2374C136.448 59.2374 137.345 58.919 137.963 58.2824C138.581 57.6367 138.89 56.7353 138.89 55.5785C138.89 54.4126 138.577 53.5024 137.95 52.8477C137.332 52.1931 136.44 51.8657 135.272 51.8657H133.626V59.2374H135.272Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_949_6192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2965 6.22561C14.2965 9.66391 11.5228 12.4512 8.10136 12.4512C4.67989 12.4512 1.90625 9.66391 1.90625 6.22561C1.90625 2.78729 4.67989 0 8.10136 0C11.5228 0 14.2965 2.78729 14.2965 6.22561Z",
    fill: "#F26064"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_949_6192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5386 6.28868C31.5386 9.76182 28.5734 12.5773 24.9156 12.5773C21.2577 12.5773 18.2925 9.76182 18.2925 6.28868C18.2925 2.81553 21.2577 0 24.9156 0C28.5734 0 31.5386 2.81553 31.5386 6.28868Z",
    fill: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_949_6192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.9748 6.22561C48.9748 9.66391 46.201 12.4512 42.7796 12.4512C39.3581 12.4512 36.5845 9.66391 36.5845 6.22561C36.5845 2.78729 39.3581 0 42.7796 0C46.201 0 48.9748 2.78729 48.9748 6.22561Z",
    fill: "#FEBB4D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_949_6192",
    x: -2.09375,
    y: 0,
    width: 20.3901,
    height: 20.4512,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_949_6192"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_949_6192",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_949_6192",
    x: 14.2925,
    y: 0,
    width: 21.2461,
    height: 20.5773,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_949_6192"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_949_6192",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_949_6192",
    x: 32.5845,
    y: 0,
    width: 20.3901,
    height: 20.4512,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_949_6192"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_949_6192",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_949_6192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 61,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ab6095644381a5d4e21519f600b6ad8d.svg";
export { ForwardRef as ReactComponent };